export enum SecurityType {
  SPOT_CURRENCY,
  FORWARD_CURRENCY,
  FUTURE,
  OTHER_ASSET,
  OTHER,
}

export interface SecurityTypeData {
  id: number
  abbrev: string
  name: string
}

export const securityTypeVal = new Map<SecurityType, SecurityTypeData>([
  [
    SecurityType.SPOT_CURRENCY,
    { id: 42, abbrev: 'FXS', name: 'Spot Currency' },
  ],
  [SecurityType.OTHER, { id: 255, abbrev: 'OTHER', name: 'Other' }],
  [
    SecurityType.FORWARD_CURRENCY,
    { id: 43, abbrev: 'FXF', name: 'Forward Currency' },
  ],
  [SecurityType.FUTURE, { id: 50, abbrev: 'FUTURE', name: 'Future' }],
  [SecurityType.OTHER_ASSET, { id: 254, abbrev: 'GENERIC', name: 'Generic' }],
])
